import ApiUtils from "../ApiUtils";

export default class ApiStudentService {

    async findStudents(data) {
        return await ApiUtils.callApi('student/find','post',data);
    }

    async deleteStudent(studentId){
        return await ApiUtils.callApi(`student/${studentId}`,'delete');
    }

    async getAStudent(studentId){
        return await ApiUtils.callApi(`student/details/${studentId}`,'get');
    }

    async updateStudent(data){
        return await ApiUtils.callApi(`student/details/update`,'post', data);
    }

    async loginAsStudent(data){
        return await ApiUtils.callApi(`admin/student/login`,'post', data, 'student'); // student portal api
    }

    async resetStudentPassword(data){
        return await ApiUtils.callApi(`student/reset-password`,'post', data);
    }

    async addStudentToMailingList(data){
        return await ApiUtils.callApi(`student/add/mailing-list`,'post', data);
    }
}